module.exports = __webpack_public_path__ + "images/pages/vocal-fold/diagram-2.png";